import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { clientActions as actions, notificationActions } from '../actions';
import { clientService } from '../services';

/* Add Client Sagas */
function* handleAddClientRequest() {
  const action = yield take(actions.addClientRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.addClient, dataParams);
    if (res.isError) {
      yield put(actions.addClientError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addClientSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addClientError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Client Sagas*/
function* handleGetAllClientRequest() {
  const action = yield take(actions.getAllClientRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.getAllClient, dataParams);

    if (res.isError) {
      yield put(actions.getAllClientError(res));

    } else {
      yield put(actions.getAllClientSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllClientError());
  }
}

/* Get Client List Sagas*/
function* handleGetClientListRequest() {
  const action = yield take(actions.getClientListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.getClientList, dataParams);

    if (res.isError) {
      yield put(actions.getClientListError(res));

    } else {
      yield put(actions.getClientListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getClientListError());
  }
}

/* Update Client Sagas */
function* handleUpdateClientRequest() {
  const action = yield take(actions.updateClientRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.updateClient, dataParams);
    if (res.isError) {
      yield put(actions.updateClientError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateClientSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateClientError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Client Sagas*/
function* handleDeleteClientRequest() {
  const action = yield take(actions.deleteClientRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.deleteClient, dataParams);
    if (res.isError) {
      yield put(actions.deleteClientError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteClientSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteClientError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Client Details Sagas */
function* handleGetClientDetailsRequest() {
  const action = yield take(actions.getClientDetailRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.getClientDetails, dataParams);
    if (res.isError) {
      yield put(actions.getClientDetailError(res));
      // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.getClientDetailSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.getClientDetailError());
    // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Client Details Sagas */
function* handleUpdateClientDetailsRequest() {
  const action = yield take(actions.updateClientDetailsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(clientService.updateClientDetails, dataParams);
    if (res.isError) {
      yield put(actions.updateClientDetailsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateClientDetailsSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateClientDetailsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* -----------Watchers------------- */
function* handleAddClientWatcher() {
  yield takeEvery(
    actions.addClientRequest,
    handleAddClientRequest,
  );
}

function* handleGetClientWatcher() {
  yield takeEvery(
    actions.getAllClientRequest,
    handleGetAllClientRequest,
  );
}

function* handleGetClientListWatcher() {
  yield takeEvery(
    actions.getClientListRequest,
    handleGetClientListRequest,
  );
}

function* handleUpdateClientWatcher() {
  yield takeEvery(
    actions.updateClientRequest,
    handleUpdateClientRequest,
  );
}

function* handleDeleteClientWatcher() {
  yield takeEvery(
    actions.deleteClientRequest,
    handleDeleteClientRequest,
  );
}

function* handleGetClientDetailsWatcher() {
  yield takeEvery(
    actions.getClientDetailRequest,
    handleGetClientDetailsRequest,
  );
}

function* handleUpdateClientDetailsWatcher() {
  yield takeEvery(
    actions.updateClientDetailsRequest,
    handleUpdateClientDetailsRequest,
  );
}



function* rootClientSaga() {
  yield all([
    handleAddClientRequest(),
    handleAddClientWatcher(),

    handleGetAllClientRequest(),
    handleGetClientWatcher(),

    handleGetClientListRequest(),
    handleGetClientListWatcher(),

    handleUpdateClientRequest(),
    handleUpdateClientWatcher(),

    handleDeleteClientRequest(),
    handleDeleteClientWatcher(),

    handleGetClientDetailsRequest(),
    handleGetClientDetailsWatcher(),

    handleUpdateClientDetailsRequest(),
    handleUpdateClientDetailsWatcher(),
  ]);
}

export default rootClientSaga;
